export const BRKS = {
  miniMax: '360px',
  mobileMax: '764px',
  tabletMax: '1199px',
  mobileMin: '361px',
  tabletMin: '765px',
  desktopMin: '1200px'
} as const;


export const STYLS = {
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
} as const;

// 하단 팝업(BottomPopupArea) 높이. GoToTop / AI 챗봇 런처의 bottom 오프셋이 이 값을 참조하므로
// 단일 소스로 유지한다 — 팝업 높이만 바꾸면 두 버튼 위치가 함께 따라온다.
export const BOTTOM_POPUP_H = {
  web: '10rem',
  mobile: '19.1rem',
} as const;
